import ListingCollection from './ListingCollection';
export default ListingCollection;
export { default as getData } from './getData';